import { useTheme } from '../contexts/ThemeContext'
import { shopArtwork } from './shopArtwork'

export default function ShopBrand({ className = '' }: { className?: string }) {
    const { themeName } = useTheme()
    const brand = {
        default: { title: 'Jackpot', image: shopArtwork.logo },
        merkur24: { title: 'Merkur24', image: shopArtwork.merkurLogo },
        habbo: { title: 'Habbo', image: '/assets/webshop/habbo-logo.png' },
        superjackpotslots: { title: 'Super Jackpot Slots', image: '/assets/webshop/superjackpotslots-logo.png' },
        'dino-casino': { title: 'Dino Casino', image: '' },
        generic: { title: 'CASINO', image: '' },
    }[themeName]
    return brand.image ? <img className={className} src={brand.image} alt={brand.title} /> : <span className={`shop-wordmark ${className}`}>{brand.title}</span>
}
